import type { PlanType } from '../../domains/access/models/Entitlements';

export function shouldShowUpgradeCta(input: {
  isDemoUser: boolean;
  planType?: PlanType | null;
  legacyPlanClaim?: string | null;
}): boolean {
  if (input.isDemoUser) return false;
  if (input.planType) return input.planType === 'free';
  return input.legacyPlanClaim
    ? input.legacyPlanClaim.toLowerCase().includes('free')
    : true;
}
